<template>
    <div class="login-bgc">
        <div class="loginTitle">牵景大数据</div>
        <div class="login-main">
            <div class="login-left">
                账号：
            </div>
            <input class="login-right" type="text" v-model="username" placeholder="请输入账号"/>
        </div>
        <div class="login-main">
            <div class="login-left">
                密码：
            </div>
            <input class="login-right" type="password" v-model="password" placeholder="请输入密码"/>
        </div>
        <div class="login-btn" @click="loginOn">登录</div>
        <div class="login-message" v-show="isShow" :style="{background:bgcolor,color:color,borderColor:color}">{{content}}</div>
    </div>
</template>
<script>
import { loginApi } from '../api/ScenicAPI';
export default {
    data(){
        return{
            username:'',
            password:'',
            content:'',
            isShow:false,
            bgcolor:"#fef0f0",
            color:'#f56c6c'
        }
    },
    methods:{
        loginOn(){
            if(this.username==''){
                this.content = '请输入账号'
                this.color = '#f56c6c'
                this.bgcolor = '#fef0f0'
                this.isShow = true
                let _this = this;
                setTimeout(function(){
                    _this.isShow = false
                },1000)
                return
            }
             if(this.password==''){
                this.content = '请输入密码'
                this.color = '#f56c6c'
                this.bgcolor = '#fef0f0'
                this.isShow = true
                let _this = this;
                setTimeout(function(){
                    _this.isShow = false
                },1000)
                return
            }
            loginApi({
                login_name:this.username,
                password:this.password,
            }).then(res => {
                console.log(res)
                this.$store.commit('setUserInfo',res.data.user_info);
                this.$store.commit('setScenicId',res.data.scenic_biz_id);
                this.$store.commit('setToken',res.data.token);
                sessionStorage.setItem('userInfo',res.data.user_info);
                 sessionStorage.setItem('scenicId',res.data.scenic_biz_id);
                sessionStorage.setItem('token',res.data.token);
                this.sessionStorage
                this.content = '登录成功'
                this.color = '#67c23a'
                this.bgcolor = '#f0f9eb'
                this.isShow = true
                let _this = this;
                setTimeout(function(){
                     _this.isShow = false
                     _this.$router.push({path:'/',query: {id:res.data.scenic_biz_id}})
                },1000)
            })
            
        }
    }
}
</script>

<style scoped>
.login-bgc{
    padding-top: 100px;
    box-sizing: border-box;
    height: 100vh;
    background-color: #2d3a4b;
}
.loginTitle{
   
    margin-bottom: 30px;
    color: #fff;
    font-size: 30px;
    text-align: center;
    font-weight: 600;
    user-select:none;
}
.login-main{
   margin:0 auto 20px;
   width: 400px;
   height: 50px;
   line-height: 50px;
   user-select:none;
}
.login-left{
    margin-right: 20px;
    display: inline-block;
    width: 66px;
    height: 50px;
    line-height: 50px;
    text-align: right;
    color: #fff;
    font-size: 20px;
}
.login-right{
    display: inline-block;
    padding:5px 10px;
    box-sizing: border-box;
    background-color: #283443;
    width: 300px;
    height: 50px;
    line-height: 50px;
    border:1px solid #666;
    border-radius: 6px;
    font-size: 15px;
    color:#fff;
    
}
.login-btn{
    margin: 30px auto;
    width: 380px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background-color: #409eff;
    text-align: center;
    border-radius: 6px;
    user-select:none;
    cursor: pointer;
    font-size: 15px;
}
.login-btn:active{
    background-color: #66b1ff;
}
.login-message{
    display: inline-block;
    padding:0 20px;
    width: 400px;
    position:absolute;
    top:30%;
    left: 50%;
    transform: translate(-50%,0);
    height: 40px;
    line-height: 40px;
    border:1px solid #666;
    border-radius: 4px;
    text-align: center;
    user-select:none;
}

</style>


// WEBPACK FOOTER //
// src/pages/login.vue